import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userinfo: '',
    login: false, //是否登录
    count: 0
  },
  //getters：提供外部获取state
  getters:{
    userinfo:state=>state.userinfo,
  },
  // mutations：创建改变状态的方法
  mutations:{
    setUserinfo(state, info) {
      state.login = true;
      state.userinfo = info;
    },
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js